import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Tabs, Tab, Paper, Grid, List, ListItem, ListItemText, ListSubheader } from '@material-ui/core';
import { FHEButton } from 'data/components';
import { Toastr } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

class ConsoProd extends PureComponent {
    static propTypes = {
        updateConsoProd: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        productModulesConsoProd: PropTypes.object.isRequired,
        updateConsoProdRight: PropTypes.bool.isRequired,
        consoProd: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { consoProd } = props;
        this.state = {
            currentTab: 0,
            loading: false,
            buttonDisabled: true,
            consoProd: JSON.parse(JSON.stringify(consoProd))
        };
    }

    handleChangeTab = (event, newTab) => {
        this.setState({ currentTab: newTab });
    };
    onChangeValueConsoProd = e => {
        const { productModulesConsoProd } = this.props;
        const currentId = parseInt(e.currentTarget.dataset.index);

        this.setState(({ consoProd, currentTab }) => {
            const activeType = Object.keys(consoProd)[currentTab];
            let listSelectionned = consoProd[activeType];
            if (consoProd[activeType][currentId]) delete listSelectionned[currentId];
            else listSelectionned[currentId] = productModulesConsoProd[currentId];
            return { buttonDisabled: false, consoProd: { ...consoProd, [activeType]: listSelectionned } };
        });
    };

    resetConsoProd = () => {
        const { consoProd } = this.props;
        this.setState({
            buttonDisabled: true,
            consoProd: JSON.parse(JSON.stringify(consoProd))
        });
    };
    saveConsoProd = () => {
        const { currentTab, consoProd } = this.state;
        const { updateConsoProd } = this.props;
        const type = Object.keys(consoProd)[currentTab];

        this.setState({ loading: true });

        return updateConsoProd(type, consoProd[type])
            .then(consoProd => {
                Toastr.success(
                    Translator.translate(
                        `generic.home.consoProd.actions.update.success`,
                        Translator.translate(
                            'generic.home.consoProd.devicesSelectionned',
                            Translator.translate(`generic.home.consoProd.${type}.title`)
                        )
                    )
                );
                this.setState({ loading: false, buttonDisabled: true, consoProd: JSON.parse(JSON.stringify(consoProd)) });
            })
            .catch(error => {
                Toastr.error(
                    error.message,
                    Translator.translate(
                        `generic.home.consoProd.actions.update.error`,
                        Translator.translate(
                            'generic.home.consoProd.devicesSelectionned',
                            Translator.translate(`generic.home.consoProd.${type}.title`)
                        )
                    )
                );
                this.setState({ loading: false });
            });
    };

    renderList = data => {
        const { classes, updateConsoProdRight } = this.props;
        return (
            <Paper elevation={3} className={classes.paper}>
                <List className={classes.list} subheader={<li />}>
                    {Object.keys(data).map(sectionId => {
                        const section = data[sectionId];
                        if (section.values.length === 0) return false;
                        return (
                            <li key={sectionId} className={classes.listSection}>
                                <ul className={classes.ul}>
                                    <ListSubheader className={classes.listSubheader}>{section.name}</ListSubheader>
                                    {section.values.map(item => {
                                        return (
                                            <ListItem
                                                key={item.id}
                                                data-index={item.id}
                                                disabled={item.disabled || !updateConsoProdRight}
                                                button
                                                onClick={this.onChangeValueConsoProd}
                                            >
                                                <ListItemText primary={item.name} />
                                            </ListItem>
                                        );
                                    })}
                                </ul>
                            </li>
                        );
                    })}
                </List>
            </Paper>
        );
    };
    renderTransfertList = type => {
        const { consoProd } = this.state;
        const { classes, productModulesConsoProd } = this.props;

        const listingProductModule = {};
        const listingSelectionnedProductModule = {};
        Object.keys(productModulesConsoProd).map(moduleId => {
            const module = productModulesConsoProd[moduleId];
            if (!listingProductModule[module.productId])
                listingProductModule[module.productId] = { name: `${module.moduleType} - ${module.productLabel}`, values: [] };
            let valueIsFree = true;
            let valueIsSelectionned = false;
            Object.keys(consoProd).map(_type => {
                const values = consoProd[_type];
                const indexValue = Object.keys(values).indexOf(moduleId);
                if (indexValue !== -1) {
                    if (type !== _type) valueIsSelectionned = true;
                    else {
                        valueIsFree = false;
                        if (!listingSelectionnedProductModule[module.productId])
                            listingSelectionnedProductModule[module.productId] = {
                                name: `${module.moduleType} - ${module.productLabel}`,
                                values: []
                            };
                        listingSelectionnedProductModule[module.productId].values.push({
                            id: moduleId,
                            name: `${module.lineCode} - ${module.lineLabel}`
                        });
                    }
                }
            });
            if (valueIsFree)
                listingProductModule[module.productId].values.push({
                    id: moduleId,
                    name: `${module.lineCode} - ${module.lineLabel}`,
                    disabled: valueIsSelectionned
                });
        });
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6}>
                    <div className={classes.containerListing}>
                        <div className={classes.titleListing}>{Translator.translate('generic.home.consoProd.availableDevices')}</div>
                        {this.renderList(listingProductModule)}
                    </div>
                </Grid>
                <Grid container item sm={12} md={6}>
                    <div className={classes.containerListing}>
                        <div className={classes.titleListing}>
                            {Translator.translate(
                                'generic.home.consoProd.devicesSelectionned',
                                Translator.translate(`generic.home.consoProd.${type}.title`)
                            )}
                        </div>
                        {this.renderList(listingSelectionnedProductModule)}
                    </div>
                </Grid>
            </Grid>
        );
    };

    render() {
        const { currentTab, consoProd, loading, buttonDisabled } = this.state;
        const { classes, updateConsoProdRight } = this.props;
        const consoIndex = Object.keys(consoProd).indexOf('conso');
        const prodIndex = Object.keys(consoProd).indexOf('prod');
        const type = Object.keys(consoProd)[currentTab];

        return (
            <div className={classes.root}>
                <Tabs value={currentTab} onChange={this.handleChangeTab} centered indicatorColor="primary" textColor="primary" variant="fullWidth">
                    <Tab
                        label={Translator.translate('generic.home.consoProd.conso.title')}
                        id={`simple-tab-${consoIndex}`}
                        aria-controls={`simple-tabpanel-${consoIndex}`}
                    />
                    <Tab
                        label={Translator.translate('generic.home.consoProd.prod.title')}
                        id={`simple-tab-${prodIndex}`}
                        aria-controls={`simple-tabpanel-${prodIndex}`}
                    />
                </Tabs>
                <TabPanel value={currentTab} index={consoIndex}>
                    {this.renderTransfertList('conso')}
                </TabPanel>
                <TabPanel value={currentTab} index={prodIndex}>
                    {this.renderTransfertList('prod')}
                </TabPanel>
                {updateConsoProdRight && (
                    <Grid container justify="center" alignItems="center" spacing={3}>
                        <Grid container item sm={12} md={6} justify="center" alignItems="center" direction="column">
                            <FHEButton
                                content={Translator.translate(`general.cancel`)}
                                clickFunction={this.resetConsoProd}
                                disabled={buttonDisabled}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} justify="center" alignItems="center" direction="column">
                            <FHEButton
                                content={Translator.translate(
                                    `generic.home.consoProd.actions.update.button`,
                                    Translator.translate(
                                        'generic.home.consoProd.devicesSelectionned',
                                        Translator.translate(`generic.home.consoProd.${type}.title`)
                                    )
                                )}
                                clickFunction={this.saveConsoProd}
                                loading={loading}
                                disabled={buttonDisabled}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {children}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);

    return {
        profile: selectors.getProfile(state)
    };
}
const styles = theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        width: '100%',
        backgroundColor: theme.palette.colors.white
    },
    containerListing: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 10
    },
    titleListing: {
        margin: 10
    },
    list: {
        position: 'relative',
        overflow: 'auto',
        backgroundColor: 'inherit',
        height: 200
    },
    listSection: {
        backgroundColor: 'inherit'
    },
    listSubheader: {
        color: theme.palette.primary.light
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0
    }
});

export default withRouter(
    renderEnvComponent('scenes/Home/components/ConsoProd', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(ConsoProd)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/ConsoProd.js